import * as yup from "yup";

export const OFFICE_ADDRESS_EDIT_FORM_SCHEMA = yup.object().shape({
  country: yup.string().required("Molimo Vas da unesete država"),
  city: yup.string().required("Molimo Vas da unesete grad"),
  state: yup.string().required("Molimo Vas da unesete općinu"),
});
